<template>
    <q-dialog ref="dialog" @hide="onDialogHide" persistent>
        <q-card class="q-dialog-plugin " style="width: 30vw; max-width: 90vw;">
            <q-toolbar class="bg-primary text-white">
                <q-toolbar-title v-text="(actionTitle + ' ' + screenTitle).trim()"></q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup></q-btn>
            </q-toolbar>

            <q-form ref="modelForm">
                <q-card-section>
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12" >
                            <q-input v-model="model.TableName" type="text" 
                                     label="Table Name *" 
                                     autofocus 
                                      maxlength="255"
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('TableName')"
                                     :error-message="fieldErrorMessage('TableName')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-6" >
                            <q-input v-model="model.SenderCode" type="text" 
                                     label="SenderCode *" 
                                      
                                      maxlength="255"
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('SenderCode')"
                                     :error-message="fieldErrorMessage('SenderCode')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-6" >
                            <q-input v-model="model.ReceiverCode" type="text" 
                                     label="ReceiverCode" 
                                      
                                      maxlength="255"
                                      
                                     :rules="[]"
                                     :error="fieldHasError('ReceiverCode')"
                                     :error-message="fieldErrorMessage('ReceiverCode')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.Description" type="text" 
                                     label="Description" 
                                      
                                      maxlength="255"
                                      
                                     :rules="[]"
                                     :error="fieldHasError('Description')"
                                     :error-message="fieldErrorMessage('Description')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-6" >
                            <q-input v-model="model.Value1" type="text" 
                                     label="Value1" 
                                      
                                      maxlength="255"
                                      
                                     :rules="[]"
                                     :error="fieldHasError('Value1')"
                                     :error-message="fieldErrorMessage('Value1')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-6" >
                            <q-input v-model="model.Value2" type="text" 
                                     label="Value2" 
                                      
                                      maxlength="255"
                                      
                                     :rules="[]"
                                     :error="fieldHasError('Value2')"
                                     :error-message="fieldErrorMessage('Value2')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-6" >
                            <q-input v-model="model.Value3" type="text" 
                                     label="Value3" 
                                      
                                      maxlength="255"
                                      
                                     :rules="[]"
                                     :error="fieldHasError('Value3')"
                                     :error-message="fieldErrorMessage('Value3')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-6" >
                            <q-input v-model="model.Value4" type="text" 
                                     label="Value4" 
                                      
                                      maxlength="255"
                                      
                                     :rules="[]"
                                     :error="fieldHasError('Value4')"
                                     :error-message="fieldErrorMessage('Value4')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-6" >
                            <q-input v-model="model.Value5" type="text" 
                                     label="Value5" 
                                      
                                      maxlength="255"
                                      
                                     :rules="[]"
                                     :error="fieldHasError('Value5')"
                                     :error-message="fieldErrorMessage('Value5')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.Comments" type="textarea" rows="8" 
                                     label="Comments" 
                                      
                                      
                                      
                                     :rules="[]"
                                     :error="fieldHasError('Comments')"
                                     :error-message="fieldErrorMessage('Comments')"
                                     
                                     dense>
                                
                                
                            </q-input>
                        </div>

                        </div>
                    </div>
                </q-card-section>
            </q-form>

            <q-toolbar>
                <div class="q-gutter-xs">
                    
                </div>

                <q-space></q-space>

                <div class="q-gutter-xs" v-if="editMode === true">
                    
                    <q-btn color="primary" :label="actionLabel" @click="onOkClick" :disable="actionLocked"></q-btn>
                    <q-btn color="white" text-color="black" label="Cancel" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
                <div class="q-gutter-xs" v-if="editMode === false">
                    
                    <q-btn color="white" text-color="black" label="Close" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
            </q-toolbar>

            <q-inner-loading :showing="loading">
                <q-spinner-gears size="50px" color="primary"></q-spinner-gears>
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<style>
    
</style>

<script>
    export { default } from './crossreferenceaddeditmodel-dialog-screen.js'
</script>